const QueuedoctorList = {
  tableList: [
    {
      id: 1,
      text: "No",
      name: "#",
      visible: true,
      className: "text-center",
    },
    {
      id: 4,
      text: "Radiologist Name",
      name: "doctor_name",
      visible: true,
      className: null,
    },
    {
      id: 10,
      text: "Queues",
      name: "queue_list",
      visible: true,
      className: null,
    },
    {
      id: 5,
      text: "Status",
      name: "status",
      visible: true,
      className: null,
    },
    {
      id: 6,
      text: "Action",
      name: "action",
      visible: true,
      className: null,
    },
  ],
};

const QueuedoctorForm = {
  feilds: [
    {
      id: 0,
      name: "addRadiologist",
      text: "Add New Radiologist",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "username",
      text: "Enter User Name",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter user Name",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your User Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 2,
      name: "password",
      text: "Enter User Password",
      visible: true,
      element: "input",
      required: true,
      input_type: "password",
      placeholder: "Enter user Password",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your password",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 3,
      name: "role",
      text: "Select Role",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Select Role",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Role",
        },
      ],
      errors: [],
      value: "Radiologist",
      valid: true,
      state: "",
      disable: true,
      className: [],
    },
    {
      id: 4,
      name: "accessLevel",
      text: "Select Access Level",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Select Access Level",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value != "" && value != undefined;
          },
          message: "Please Select Access Level",
        },
      ],
      errors: [],
      value: "Unit Level",
      valid: true,
      state: "",
      disable: true,
      className: [],
    },
    {
      id: 5,
      name: "unit",
      text: "Select Unit",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Unit",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Unit",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 9,
      name: "new_queues",
      text: "Select Queue",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Queue",
      icon: "lock",
      rules: [],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 20,
      name: "button",
      text: "Radiologist",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

export { QueuedoctorList, QueuedoctorForm };
